(ns rlws.iot-cloud.frontend.views
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [rlws.iot-cloud.frontend.account :as account]
            [rlws.iot-cloud.frontend.admin :as admin]
            [rlws.iot-cloud.frontend.assets :as assets]
            [rlws.iot-cloud.frontend.builder :as builder]
            [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.components :as components]
            [rlws.iot-cloud.frontend.customers :as customers]
            [rlws.iot-cloud.frontend.global-messages :as messages]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.frontend.config :as config]))

(defn fallback-view
  [reset-error]
  [:div
   [:h2 "Something went wrong"]
   [:button.btn.mr-2 {:on-click reset-error} "Try Again"]
   [:button.btn {:on-click #(rf/dispatch [:navigate config/home-route])} "Return Home"]])

(defn views
  []
  (let [modal-state (r/atom nil)]
    (fn []
      (let [page @(rf/subscribe [::sub/page])
            permissions (:permissions @(rf/subscribe [::sub/current-user]))
            customizations @(rf/subscribe [::sub/customizations])
            hide-breadcrumb? (not (some #(= page %)
                                        '(:account-settings :homepage)))
            show-menu? @(rf/subscribe [:show-menu?])]
        [:<>
         (case page
           ;; pages that don't need the header/nav of the main app
           :login [components/login page]
           :signup [components/signup page]
           :forgot-password [components/forgot-password page]
           :reset-password [components/reset-password page]
           (if-not customizations
             [components/page-loader]
             [:<>
              [components/header page]
              [components/navigation page]
              [:div.page-content
               {:class (when show-menu? "nav-open")}
               [components/error-boundary
                {:key page
                 :fallback fallback-view}
                (case page
                  :asset [assets/one-asset]
                  :customers [customers/all-customers]
                  :customer [customers/one-customer]
                  :site [customers/one-site]
                  :iqube-detail [assets/one-iqube] 
                  :assets [assets/all-assets]
                  :asset-profile [assets/asset-profile]
                  :add-asset [builder/add-asset-view]
                  :edit-asset [builder/edit-asset-view]
                  :add-customer [builder/add-customer-view]
                  :homepage [admin/home]
                  :account-settings [account/info]
                  :notification-settings [account/notification-settings]
                  (fn []
                    (rf/dispatch [:navigate config/home-route])))]
               [common/pprint-code @(rf/subscribe [:db])]]
              (when @(rf/subscribe [:settings-popover])
                [components/profile-popover])
              [components/modal]]))
         [messages/toast]]))))
